<template>
  <VueFinalModal
    v-model="isOpen"
    v-bind="$attrs"
    content-class="pointer-events-none fixed inset-0 flex items-center justify-end overflow-auto md:justify-center"
    :z-index-base="100000"
    esc-to-close
  >
    <div class="pointer-events-auto flex size-full items-center justify-center overflow-hidden sm:w-auto md:h-auto md:rounded-3xl">
      <div class="relative flex size-full flex-col bg-background sm:w-[400px] md:h-auto md:w-[800px]">
        <button class="absolute right-4 top-3 flex rounded-full p-2 transition-colors hover:bg-background-none-hover active:bg-background-none-active" @click="isOpen = false">
          <span class="sr-only">{{ t['w.modal.close']() }}</span>
          <Icon name="close" class="size-6" />
        </button>
        <h4 class="flex justify-center bg-background-light-strong px-6 py-5 text-h4 text-text-dark-strong">
          <Icon name="check-circle" class="mr-3 size-6 text-text-dark-strong" />
          {{ t['w.module.product_modal.product_added']() }}
        </h4>
        <div class="flex grow flex-col items-center overflow-auto">
          <!-- TODO: Develop feature support for extra warranty -->
          <!--div v-if="product" class="flex w-full items-center justify-center gap-6 px-10 py-6">
            <div class="flex items-center" :class="product.warranty && 'basis-1/2'">
              <OnImg
                :src="product.imageUrl ? product.imageUrl : product.image"
                :alt="product.name"
                class="aspect-[7/5] h-[84px] w-auto rounded-2xl object-cover"
                loading="lazy"
                decoding="async"
                sizes="sm:400px lg:700px"
              />
              <div class="ml-5">{{ product.name }}</div>
            </div>
            <div v-if="product.warranty" class="basis-1/2 rounded-xl bg-background-dark p-4">
              <CheckboxInput v-model="hasWarranty" class="text-button-m font-medium" :label="t['w.global.product_warranty']()">
                <Icon name="guard" class="ml-1.5 mr-3 size-6 text-icon-soft" />
                {{ warrantyLabel }}
              </CheckboxInput>
            </div>
          </div-->
          <div class="w-full px-10 pb-10 pt-8">
            <!-- TODO: Add free shipping remainder calculation support once marketing requests it -->
            <!--div class="mb-8 text-center text-subheading font-medium" v-html="freeShippingLabel" /-->
            <div class="flex flex-col gap-5 md:flex-row md:justify-center md:px-32">
              <Button class="btn-secondary btn-rounded w-full py-3" @click="isOpen = false">{{ t['w.module.product_modal.continue_shopping']() }}</Button>
              <Button link="/order/basket" class="btn-rounded w-full py-3">{{ t['w.module.product_modal.goto_cart']() }}</Button>
            </div>
          </div>
          <div v-if="recommendedHalls.length" class="flex w-full grow flex-col items-center bg-background-medium px-10 py-8">
            <div class="mb-8 text-subheading font-medium">{{ t['w.module.product_modal.similar_products']() }}</div>
            <ul class="-mx-2.5 -mb-6 flex w-full flex-wrap justify-center md:px-[90px]">
              <li v-for="(hall, index) in recommendedHalls" :key="index" class="basis-1/2 px-2.5 pb-6 md:basis-1/4">
                <RecommendedHall :hall="hall" :index="index" :show-icon="showIcons" class="text-center text-base" @click="isOpen = false" />
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </VueFinalModal>
</template>

<script setup lang="ts">
import Icon from '~/components/icon/Icon.vue'
import RecommendedHall from '~/components/product/RecommendedHall.vue'
import { VueFinalModal } from 'vue-final-modal'

import { useProductModalStore } from '~/stores/product-modal'
import * as t from '~/messages'

const productModal = useProductModalStore()
const isOpen = computed({
  get: () => {
    return productModal.isOpen
  },
  set: (newValue) => {
    productModal.setIsOpen(newValue)
  },
})

/* TODO: Add free shipping remainder calculation support once marketing requests it
const freeShippingRemainder = 32.56 // placeholder - can be rewritten to use translation as freeShipping limit and then calculated properly

const freeShippingLabel = computed(() => {
  return t['w.module.product_modal.free_shipping']().replace(/%s( .)? /, `<span class="text-text-strong">${freeShippingRemainder}$1</span> `)
})
*/

/* TODO: Develop feature support for extra warranty
const product = computed(() => productModal.getProduct())

const hasWarranty = computed({
  get: () => {
    return productModal.hasWarranty
  },
  set: (newValue) => {
    productModal.setHasWarranty(newValue)
  },
})

const warrantyLabel = computed(() => {
  if (!product.value || !product.value.warranty) {
    return false
  }

  return t['w.global.product_warranty']().replace('%s', product.value.warranty.length).replace('%s', product.value.warranty.price)
})
*/

const recommendedHalls = computed(() => productModal.recommendedHalls)

const showIcons = computed(() => {
  return recommendedHalls.value.every((hall) => hall.icon)
})

watch(
  () => isOpen.value,
  () => {
    if (isOpen.value) {
      document.documentElement.style.overflow = 'hidden'
    } else {
      document.documentElement.style.overflow = ''
    }
  }
)

// TODO(Indrek): When modal closes due to clicking on a NuxtLink inside modal, the overflow is still set.
// Following hack will unset it.
// This indicates that the watcher above is the wrong way to implement a lock for scroll.
onBeforeUnmount(() => {
  if (isOpen.value) {
    document.documentElement.style.overflow = ''
    isOpen.value = false // Possibly no-op
    productModal.setIsOpen(false)
  }
})
</script>
